import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrontendShellRoutingModule } from './frontend-shell.routing';

@NgModule({
  imports: [CommonModule, FrontendShellRoutingModule],
})
export class FrontendShellModule {}
